import "./Logo.css";

export function Logo() {
  return (
    <div className="home-logo">
      Automated <br />
      Journalist
    </div>
  );
}
